import { IOkved } from 'APIPackage/KnmModule/interfaces/IOkved';

import { IOkvedSelectOption } from '../interfaces/IOkvedSelectOption';

export const createOkvedSelectOption = (okved: IOkved): IOkvedSelectOption => ({
  ...okved,
  id: okved.code,
  label: `${okved.code} ${okved.name}`,
  value: okved.code,
});
